import { ref, computed } from "vue";
import store from "@/store";
import { i18n } from "@/i18n";

export function usePhoto(props, emit) {
  const isLoading = ref(false);
  const photoSrc = computed(() => {
    // socialmedia
    if (props.photo.socialmedia) return props.photo.socialmedia;
    // preview
    if (props.photo.preview) return props.photo.preview;

    return props.photo.watermarked_preview;
  });
  const downloadLink = computed(() => {
    return (
      props.photo.original ||
      props.photo.socialmedia ||
      props.photo.watermarked_preview
    );
  });

  const downloadCertificate = async () => {
    if (props.purchaseStatus === "no_order_found")
      return emit("error", {
        text: "result_error_certificate_unavailable",
        certificateDialog: true,
      });

    if (isLoading.value) return;
    let windowReference = window.open();

    if (windowReference) {
      const doc = windowReference.document;

      const html = doc.createElement("html");
      const head = doc.createElement("head");
      const title = doc.createElement("title");
      title.innerText = "Loading...";

      const body = doc.createElement("body");
      body.style.display = "flex";
      body.style.alignItems = "center";
      body.style.justifyContent = "center";
      body.style.height = "100vh";
      body.style.fontFamily = "sans-serif";

      const message = doc.createElement("div");
      message.innerText = i18n.t("result_certificate_blank_page_text");

      head.appendChild(title);
      body.appendChild(message);
      html.appendChild(head);
      html.appendChild(body);

      doc.body.replaceWith(body);
      doc.head.replaceWith(head);
    }

    isLoading.value = true;
    try {
      const link = await store.dispatch("getPhotoCertificate", {
        resultId: props.resultId,
        mediaId: props.photo.media_id,
      });
      windowReference.location = link;
      //   if (link) downloadPhoto(link);
    } catch (error) {
      console.log(error);
      emit("error", { text: "result_error_certificate_download" });
    } finally {
      isLoading.value = false;
    }
  };

  const downloadPhoto = (link) => {
    try {
      let a = document.createElement("a");
      a.href = link;
      a.setAttribute("download", `${props.photo.athlete_image_id}.jpg`);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.log("Download photo error", error);
    }
  };
  return {
    isLoading,
    photoSrc,
    downloadLink,
    downloadCertificate,
    downloadPhoto,
  };
}
